// extracted by mini-css-extract-plugin
export var divider = "_2p-0";
export var dividerText = "_2p-1";